<template>
  <div>
    <h3 class="title">Recursos Humanos</h3>

    <Graphics v-if="!datos" :listData="listData" />

    <Tables v-if="!datos" :permiso="permiso" :valor="valor" />

    <div v-if="!spin">
        <AlertError v-if="datos" />
    </div>
  

    <div v-if="spin">
      <Loading v-if="datos" />
    </div>
  </div>
</template>

<script>
// import Upload from "./Upload.vue";
import Graphics from "./Graphics.vue";
// import Help from "../../../components/tools/Modal.vue";
import Tables from "./Tables.vue";
import { mapState } from "vuex";
import axios from "axios";
// import TablaAsco from "./TablaAsco.vue";
import AlertError from "../../../components/error/AlertError.vue";
import Loading from "../../../components/tools/Loading.vue";
export default {
  components: {
    // Upload,
    Graphics,
    // Help,
    Tables,
    AlertError,
    Loading,
  },
  data() {
    return {
      permiso: false,
      title: "Recursos Humanos",
      text:
        "La información de esta sección debe ser elaborada con los antecedentes entregados a Dipres en la matriz D correspondiente al IV Informe Trimestral de Dotación de Personal 2020, con información proporcionada en anteriores BGI y de conformidad con los criterios que se indican a continuación.",
      text_one:
        "Para la elaboración de este documento, considere la versión de su matriz D que incorpore todas las correcciones solicitadas por Dipres.",
      datos: true,
      listData: [],
      statusTable: null,
      dataTable: [],
      valor: [],
     spin: false
    };
  },

  computed: {
    ...mapState("sesion", ["usuario"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
  },

  methods: {
    obtenerRelacionUsuarioServicio() {
      const data = JSON.parse(localStorage.getItem("user"));
      const relacionUs = data.servicios.find(
        (s) => s.id === parseInt(this.$route.params.idServicio)
      );
      if (!relacionUs) return;
      // console.log(relacionUs);
      if (
        relacionUs.permisos.find((p) => p.permisoId === 4) ||
        relacionUs.rolId === 3 ||
        relacionUs.rolId === 4 ||
        relacionUs.rolId === 5
      ) {
        this.permiso = true;
      }
    },

    obtenerContenido: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/public_list/?anexo=2&servicio=${this.$route.params.idServicio}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data === undefined) {
          this.datos = true;
        }
        const data =
          res.data[0].datos.indicadores[`${process.env.VUE_APP_ANIO}`][15];
        this.listData = data;
        this.datos = false;
        this.valor = res.data[0].datos.modificado;
      } catch (error) {
        console.log(error);
      }
    },

    builDataFinalizado: function(type) {
      // console.log(type);
      return {
        anio: process.env.VUE_APP_ANIO,
        idServicio: this.$route.params.idServicio,
        data: this.dataTable,
        elaboracion: type,
        nombre: "recursos_humanos",
      };
    },

    statusTableFunction: function() {
      if (this.statusTable === null) {
        this.statusTable = true;
        // console.log("status", this.statusTable);
      } else {
        this.statusTable = null;
      }
    },
  },

  mounted() {
    this.obtenerRelacionUsuarioServicio();
    this.obtenerContenido();
    setTimeout(() => {
      if (this.valor === null) {
        this.spin = false
        return this.datos
      }
    }, 20000);
  },
};
</script>

<style scoped>
.row {
  margin: 0;
}

.fnc-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title {
  text-align: center;
  margin-bottom: 20px;
}

.btn-humanos {
  margin-bottom: 20px;
}

.bx-download {
  font-size: 25px;
  margin-right: 10px;
}

.span-btn-text {
  font-size: 18px;
}

.bx-upload {
  font-size: 25px;
  margin-right: 10px;
}
.mt-3 {
  background: #4f52ff !important;
  color: #fff !important;
  border: none;
  margin-left: 10px;
  margin-top: -20px;
}
.button {
  border: none;
  cursor: pointer;
  width: 12%;
  height: 30px;
  margin-bottom: 20px;
  background: #0b5ed7;
  color: #fff;
  border-radius: 20px;
  margin-right: 20px;
}

.button:hover {
  color: #fff;
  background: blueviolet;
}

.div-button {
  display: flex;
  justify-content: center;
}
</style>
